/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_ModalInputs */



/**
* | output |
* | --- |
* | "Close modal" |
*
* @param {Close_ModalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_modal = /** @type {((inputs?: Close_ModalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_ModalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la fenêtre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Modal schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi modale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть модальное окно")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar modal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭模态框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("モーダルを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मॉडल बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar modal")
	return /** @type {LocalizedString} */ ("Close modal")
});